module.exports = __webpack_public_path__ + "static/img/13.c181be51.png";